import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Grid,
  Divider,
  Button,
  TextField,
} from "@mui/material";

const AddPaymentMethodModal = ({ open, handleClose }) => {
  const [formData, setFormData] = useState({
    bankName: "",
    accountHolderName: "",
    accountNumber: "",
    ifscCode: "",
    upiId: "",
    cardAccountNumber: "",
    cardHolderName: "",
    expiryDate: "",
    cvv: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        className="bg-white rounded-3 shadow"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95%",
          maxWidth: "1000px",
          maxHeight: "90vh",
          overflowY: "auto",
          p: 4,

          // Scrollbar
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ccc",
            borderRadius: "15px",
          },
        }}
      >
        <Typography variant="h6" fontWeight={600} className="text-center mb-4">
          Add Payment Methods
        </Typography>

        {/* --- Bank Details --- */}
        <Box className="border rounded-3 p-3 bg-white mb-4">
          <Typography fontWeight={600}>Add Bank Details</Typography>

          <Grid container spacing={3}>
            {[
              {
                label: "Bank Name",
                name: "bankName",
                placeholder: "Enter Bank Name",
              },
              {
                label: "Account Holder Name",
                name: "accountHolderName",
                placeholder: "Enter Account Holder Name",
              },
              {
                label: "Account Number",
                name: "accountNumber",
                placeholder: "Enter Account Number",
              },
              {
                label: "IFSC Code",
                name: "ifscCode",
                placeholder: "Enter IFSC Code",
              },
            ].map((field, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  mb={0.5}
                  sx={{ fontSize: "14px" }}
                >
                  {field.label}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder={field.placeholder}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "#fafafa",
                    },
                    "& input": {
                      fontSize: "14px",
                      //   height: "44px",
                      border: "none !important",
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <Divider className="my-4">OR</Divider>

        {/* --- UPI ID --- */}
        <Box className="border rounded-3 p-3 bg-white mb-4">
          <Typography fontWeight={600} mb={2}>
            Add UPI ID
          </Typography>
          <Box mb={3}>
            <TextField
              fullWidth
              size="small"
              name="upiId"
              placeholder="Add Your UPI ID"
              value={formData.upiId}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  backgroundColor: "#fafafa",
                },
                "& input": {
                  fontSize: "14px",
                  border: "none !important",
                },
              }}
            />
          </Box>
        </Box>

        <Divider className="my-4">OR</Divider>

        {/* --- Credit/Debit Card --- */}
        <Box className="border rounded-3 p-3 bg-white mb-4">
          <Typography fontWeight={600} mb={2}>
            Add Credit/Debit Card Details
          </Typography>
          <Grid container spacing={3}>
            {[
              {
                label: "Account Number",
                name: "cardAccountNumber",
                placeholder: "Enter Account Number",
              },
              {
                label: "Account Holder Name",
                name: "cardHolderName",
                placeholder: "Enter Account Holder Name",
              },
              {
                label: "Expiry Date",
                name: "expiryDate",
                placeholder: "Enter Expiry Date",
              },
              { label: "CVV", name: "cvv", placeholder: "Enter CVV" },
            ].map((field, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  mb={0.5}
                  sx={{ fontSize: "14px" }}
                >
                  {field.label}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  name={field.name}
                  placeholder={field.placeholder}
                  value={formData[field.name]}
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "#fafafa",
                    },
                    "& input": {
                      fontSize: "14px",
                      border: "none !important",
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* --- Add Button --- */}
        <Box className="text-end mt-4">
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              px: 4,
              backgroundColor: " rgba(107, 142, 118, 1)",
            }}
          >
            Add
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddPaymentMethodModal;
